export const OPEN_DIALOG = "[SCREENLOCK APP] OPEN DIALOG";
export const DISABLED_LOCK = "[SCREENLOCK APP] DISABLED LOCK";

export function openDialog(_AValue) {
    return (dispatch) => {
        Promise.all([
            dispatch({
                type: OPEN_DIALOG,
                open: _AValue,
            })
        ]);
    };
}

export function disableScreenLock(_AValue = true) {
    return (dispatch) => {
        Promise.all([
            dispatch({
                type: DISABLED_LOCK,
                disabled: _AValue,
            })
        ]);
    };
}

